import React from 'react';

function AreaFalse() {
  return (
    <React.Fragment>
      <div id='checkout-header' />
      <h1 style={{ textAlign: 'center', marginTop: '30vh' }}>
        Sorry, But we do not operate in this area yet.
      </h1>
    </React.Fragment>
  );
}

export default AreaFalse;



// WEBPACK FOOTER //
// ./src/AreaFalse.js